{
  "mappings": [
    {
      "category": "User Communication Data",
      "titles": ["your_address_books.json", "friends.json", "message_1.json"]
    },
    {
      "category": "User-Generated Content",
      "titles": [
        "posts_and_comments.json",
        "your_posts_1.json",
        "9184_393_o_59.jpg",
        "4789_821_o_90.jpg",
        "9130_899_o_49.jpg",
        "1383_118_o_2.jpg",
        "4547_644_o_53.jpg",
        "1334_153_o_18.jpg",
        "3124_702_o_43.jpg",
        "9066_796_o_16.jpg",
        "4960_500_o_18.jpg",
        "2768_558_o_43.jpg",
        "8974_564_o_86.jpg",
        "1486_925_o_58.jpg",
        "5986_794_o_14.jpg",
        "9789_931_o_0.jpg",
        "4861_909_o_96.jpg",
        "2715_804_o_61.jpg",
        "6641_277_o_56.jpg",
        "538_308_o_82.jpg",
        "5465_690_o_11.jpg",
        "2635_698_o_71.jpg",
        "2133_134_o_95.jpg",
        "4165_476_o_59.jpg",
        "1501_209_o_81.jpg",
        "988_348_o_8.jpg",
        "8840_188_o_9.jpg",
        "5878_906_o_87.jpg",
        "9350_377_o_89.jpg",
        "12_529_o_72.jpg",
        "7889_556_o_37.jpg",
        "2241_326_o_50.jpg",
        "2346_883_o_89.jpg",
        "3983_147_o_82.jpg",
        "1270_283_o_35.jpg",
        "5077_32_o_77.jpg",
        "8882_898_o_48.jpg",
        "2317_299_o_7.jpg",
        "5033_327_o_92.jpg",
        "5230_172_o_70.jpg",
        "9816_531_o_59.jpg",
        "8443_886_o_67.jpg",
        "2084_820_o_8.jpg",
        "6997_635_o_16.jpg",
        "72_677_o_22.jpg",
        "6906_515_o_71.jpg",
        "2398_738_o_24.jpg",
        "236_251_o_52.jpg",
        "5846_967_o_80.jpg",
        "2379_691_o_38.jpg",
        "4976_975_o_97.jpg",
        "3278_825_o_69.jpg",
        "3310_555_o_70.jpg",
        "5975_545_o_43.jpg",
        "5018_302_o_15.jpg",
        "2791_568_o_88.jpg",
        "5524_32_o_39.jpg",
        "3196_432_o_46.jpg",
        "4996_344_o_23.jpg",
        "6142_213_o_85.jpg",
        "7495_965_o_43.jpg",
        "2371_617_o_56.jpg",
        "7982_466_o_22.jpg",
        "7440_295_o_72.jpg",
        "7625_519_o_27.jpg",
        "8324_808_o_13.jpg",
        "3375_688_o_8.jpg",
        "3713_398_o_34.jpg",
        "1922_387_o_26.jpg",
        "6055_654_o_72.jpg",
        "3553_496_o_22.jpg",
        "991_915_o_16.jpg",
        "5737_788_o_2.jpg",
        "5723_768_o_91.jpg",
        "3338_903_o_48.jpg",
        "7228_941_o_97.jpg",
        "6460_120_o_44.jpg",
        "17_644_o_37.jpg",
        "6549_423_o_16.jpg",
        "3304_393_o_40.jpg",
        "219_229_o_87.jpg",
        "8454_341_o_1.jpg",
        "8331_274_o_13.jpg",
        "7874_108_o_26.jpg",
        "1944_795_o_0.jpg",
        "6995_741_o_32.jpg",
        "8290_707_o_9.jpg",
        "7655_270_o_7.jpg",
        "5911_690_o_50.jpg",
        "5262_743_o_67.jpg",
        "3175_704_o_7.jpg",
        "527_566_o_2.jpg",
        "8599_228_o_16.jpg",
        "5576_924_o_62.jpg",
        "8295_648_o_88.jpg",
        "94_621_o_93.jpg",
        "205_306_o_72.jpg",
        "8727_517_o_42.jpg",
        "504_107_o_73.jpg",
        "2729_928_o_43.jpg",
        "70_426_o_39.jpg",
        "9853_406_o_24.jpg",
        "1938_346_o_8.jpg",
        "6435_818_o_77.jpg",
        "6126_164_o_66.jpg",
        "8344_193_o_69.jpg",
        "3535_887_o_79.jpg",
        "6087_373_o_1.jpg",
        "4522_638_o_30.jpg",
        "5_831_o_44.jpg",
        "8800_611_o_69.jpg",
        "7474_657_o_78.mp4",
        "1648_827_o_67.mp4",
        "6420_634_o_82.mp4",
        "6366_110_o_82.mp4",
        "9278_381_o_50.mp4",
        "7591_626_o_86.mp4",
        "9779_769_o_67.mp4",
        "9572_501_o_50.mp4",
        "3247_995_o_44.mp4",
        "1613_334_o_53.mp4",
        "6982_508_o_96.mp4",
        "7748_919_o_49.mp4"
      ]
    },
    {
      "category": "Profile and Social Graph Data",
      "titles": ["your_address_books.json", "friends.json", "pages.json", "profile_information.json"]
    },
    {
      "category": "Usage Data",
      "titles": ["your_search_history.json", "logins_and_logouts.json", "profile_update_history.json"]
    },
    {
      "category": "Transaction Data",
      "titles": ["no_matching_file"]
    },
    {
      "category": "Device and Network Information",
      "titles": ["location.json", "no_matching_file"]
    },
    {
      "category": "Tracking and Third-Party Data",
      "titles": ["no_matching_file"]
    },
    {
      "category": "Sensitive Personal Information",
      "titles": ["no_matching_file"]
    },
    {
      "category": "AI Interaction Data",
      "titles": ["no_matching_file"]
    },
    {
      "category": "Activity Metadata",
      "titles": [
        "your_search_history.json",
        "posts_and_comments.json",
        "your_posts_1.json",
        "profile_update_history.json"
      ]
    },
    {
      "category": "Contact and Profile Information",
      "titles": ["your_address_books.json", "profile_information.json"]
    },
    {
      "category": "Content Interaction Data",
      "titles": ["posts_and_comments.json", "your_posts_1.json", "message_1.json"]
    }
  ]
}
